import {DefaultModule, registerModule} from "../../builder/DashboardConfigServiceRegistry";

registerModule("ICP4", new class extends DefaultModule {
    overrideUIStrings() {
        return {
          "Asset Management": "SolarSense"
        }
      }
})